export default window._cmsContent['solar/your-current-supplier']